<template>
	<Icon class="text-gray-light animate-spin inline-block" type="spinner" size="sm"></Icon>
</template>
